module.exports = __webpack_public_path__ + "static/media/Group_2472_invert.51741dcd.png";